var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMapsFill = function SvgMapsFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    className: "maps-fill_svg__svg-icon",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m12.9 21-2.85-7.05L3 11.1V9.7L21 3l-6.7 18z"
  })));
};
export { SvgMapsFill as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjQgMjQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgY2xhc3M9InN2Zy1pY29uIj48ZyBpZD0ibWFwcyBmaWxsIj48cGF0aCBpZD0idmVjdG9yIiBkPSJNMTIuOSAyMUwxMC4wNSAxMy45NUwzIDExLjFWOS43TDIxIDNMMTQuMyAyMUgxMi45WiIgZmlsbD0iY3VycmVudENvbG9yIi8+PC9nPjwvc3ZnPg==";